module.exports = __webpack_public_path__ + "static/media/kesica2_in_1_RGB_za_net.9763ed56.png";